import { BuildingOfficeIcon } from "@heroicons/react/24/solid";
import React, { useMemo } from "react";
import { useRecoilValue } from "recoil";
import { accountAtom } from "../../Login/atoms/AccountAtom";
import DynamicTable from "./DynamicReports/DynamicTable";
import useGetReportsTab from "./DynamicReports/hooks/useGetReportsTab";

export const SideBarData = () => {
  const { data: reports, isFetching } = useGetReportsTab();
  const user = useRecoilValue(accountAtom);

  const reportsData =
    reports &&
    reports?.map((x) => {
      return {
        path: x.path,
        title: x.moduleName,
        icon: <BuildingOfficeIcon className="h-4 w-4 mr-2" />,
        permission: x.permission,
        subNav: x.subNav
          ?.filter((g) =>
            g.permissionIds?.some((d) => d.roleId === user?.roleId)
          )
          .map((c) => {
            return {
              title: c.reportName,
              to: c.path,
              component: DynamicTable,
              permission: c.permissionIds,
            };
          }),
      };
    });

  const memResult = useMemo(() => {
    const data = reportsData?.filter((c) => c.subNav?.length > 0);
    return data;
  }, [reportsData]);

  return { memResult, isFetching };
};
